import React, { useState, useEffect, useMemo } from "react";
import * as S from "./ModalUserStyle";
import Loading from "../Loader";
import { adminService } from "../../Services/adminService";
import _ from "lodash";

// MAPA DE PERMISSÕES CORRIGIDO
const PERMISSIONS_MAP = [
  { key: "admin", label: "Administradores" },
  { key: "client", label: "Clientes" },
  { key: "contract", label: "Contratos" },
  { key: "consultant", label: "Consultores" },
  { key: "contract_validation", label: "Validar Contratos" },
  { key: "withdraw", label: "Saques" },
  { key: "withdraw_validation", label: "Validar Saques" },
  { key: "indication", label: "Indicações" },
  { key: "news", label: "Notícias" },
  { key: "messages", label: "Mensagens" },
  { key: "audit", label: "Auditoria" },
  { key: "data_extract", label: "Extração de Dados" },
  { key: "receiving_accounts", label: "Contas de Depósito" },
];

const ensureAllPermissionKeys = (permissions) => {
  const fullPermissions = {};
  PERMISSIONS_MAP.forEach((perm) => {
    fullPermissions[perm.key] = permissions?.[perm.key] || false;
  });
  return fullPermissions;
};

export default function ModalUser({ userData, onClose, onUserUpdated }) {
  const [editedData, setEditedData] = useState(null);
  const [originalData, setOriginalData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const initialData = {
      ...userData,
      viewPermissions: ensureAllPermissionKeys(userData.viewPermissions),
      editPermissions: ensureAllPermissionKeys(userData.editPermissions),
    };
    setEditedData(initialData);
    setOriginalData(_.cloneDeep(initialData));
  }, [userData]);

  const handlePermissionToggle = (type, key) => {
    setEditedData((prev) => ({
      ...prev,
      [`${type}Permissions`]: {
        ...prev[`${type}Permissions`],
        [key]: !prev[`${type}Permissions`][key],
      },
    }));
  };

  const hasChanges = useMemo(() => {
    if (!originalData || !editedData) return false;
    return !_.isEqual(originalData, editedData);
  }, [originalData, editedData]);

  const handleSave = async () => {
    if (!hasChanges) {
      alert("Nenhuma alteração foi feita.");
      return;
    }
    setLoading(true);
    try {
      const promises = [];
      if (
        !_.isEqual(originalData.viewPermissions, editedData.viewPermissions)
      ) {
        promises.push(
          adminService.updateViewPermissions(
            userData.id,
            editedData.viewPermissions
          )
        );
      }
      if (
        !_.isEqual(originalData.editPermissions, editedData.editPermissions)
      ) {
        promises.push(
          adminService.updateEditPermissions(
            userData.id,
            editedData.editPermissions
          )
        );
      }
      await Promise.all(promises);
      alert("Permissões atualizadas com sucesso!");
      onUserUpdated();
    } catch (error) {
      alert(
        `Erro ao atualizar permissões: ${
          error.response?.data?.message || error.message
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  if (!editedData)
    return (
      <S.ModalOverlay>
        <Loading load={true} />
      </S.ModalOverlay>
    );

  const renderPermissionBox = (type, title) => (
    <S.PermissionsBox>
      <h5>{title}</h5>
      <S.PermissionsList>
        {PERMISSIONS_MAP.map((permission) => (
          <S.PermissionItem
            key={`${type}-${permission.key}`}
            onClick={() => handlePermissionToggle(type, permission.key)}
          >
            <S.Checkbox
              checked={
                editedData[`${type}Permissions`]?.[permission.key] || false
              }
            />
            <span>{permission.label}</span>
          </S.PermissionItem>
        ))}
      </S.PermissionsList>
    </S.PermissionsBox>
  );

  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContainer onClick={(e) => e.stopPropagation()}>
        <Loading load={loading} />
        <S.ModalHeader>
          <h3>Editar Permissões: {userData.name}</h3>
          <S.CloseButton onClick={onClose}>&times;</S.CloseButton>
        </S.ModalHeader>
        <S.ModalBody>
          <S.FormGrid>
            <S.InputGroup>
              <label>Nome</label>
              <input type="text" value={editedData.name || ""} readOnly />
            </S.InputGroup>
            <S.InputGroup>
              <label>Email</label>
              <input type="email" value={editedData.email || ""} readOnly />
            </S.InputGroup>
          </S.FormGrid>
          <S.PermissionsSectionTitle>
            Definir Permissões
          </S.PermissionsSectionTitle>
          <S.PermissionsGrid>
            {renderPermissionBox("view", "Permissões de Visualização")}
            {renderPermissionBox("edit", "Permissões de Edição")}
          </S.PermissionsGrid>
        </S.ModalBody>
        <S.ModalFooter>
          <S.CancelButton onClick={onClose} disabled={loading}>
            Cancelar
          </S.CancelButton>
          <S.SaveButton onClick={handleSave} disabled={loading || !hasChanges}>
            Salvar Alterações
          </S.SaveButton>
        </S.ModalFooter>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
